import React from 'react';
import PropTypes from 'prop-types';

const bannerType = {
  logoBanner: 'logo-banner', // Styles for banner with logo or Avatar
  banner: 'banner', // Styles for banner without logo or avatar
};

const BannerHeader = ({ type, children }) => {
  return <div className={bannerType[type]}>{children}</div>;
};

export const Banner = ({ bannerURL }) => {
  return (
    <section
      className="banner-img"
      style={{ backgroundImage: `url(${bannerURL})` }}
    />
  );
};

export const Avatar = ({ logoURL }) => {
  return <img className="avatar" src={logoURL} alt="logo" />;
};

BannerHeader.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Avatar.propTypes = {
  logoURL: PropTypes.string,
};

Banner.propTypes = {
  bannerURL: PropTypes.string,
};

export default BannerHeader;
